import { connect } from 'react-redux';
import { StateType } from '../../../../state/state.types';

const mapState = ({ notifications }: StateType) => ({
  isNew: notifications.isNew,
});

export const Connect = connect(mapState);
